import cloneDeep from 'lodash/cloneDeep';

import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import {
  LinkData,
  Model,
  ModelData,
  ModelSnapshot,
  NodeData,
} from 'src/containers/ProjectDiagram/types/model';
import {
  isMapping,
  isModelConceptRelationship,
} from 'src/containers/ProjectDiagram/utils/data';

export const createDraftData = (
  model: ModelSnapshot | Model
): NonNullable<ModelData['draftData']> => {
  const prevNodeDataArray = cloneDeep(model.nodeDataArray);
  const prevLinkDataArray = cloneDeep(model.linkDataArray);
  const prevModelData = cloneDeep(model.modelData);

  const originalIrisByCurrentIri = {};
  const originalSpgNamesByCurrentName = Object.keys(
    prevModelData.sensitivePropertyGroupsByName
  ).reduce<Record<string, string>>((acc, spgName) => {
    acc[spgName] = spgName;
    return acc;
  }, {});

  const prevNodeDataMap: Record<string, NodeData> = {};
  prevNodeDataArray.forEach((data) => {
    prevNodeDataMap[data.key] = data;
  });

  const prevLinkDataMap: Record<string, LinkData> = {};
  const prevRelationshipValues: Record<string, boolean> = {};
  const prevMappingDataMap: Record<string, Mapping> = {};
  prevLinkDataArray.forEach((data) => {
    prevLinkDataMap[data.key] = data;
    if (isModelConceptRelationship(data)) {
      prevRelationshipValues[data.value] = true;
    } else if (isMapping(data)) {
      prevMappingDataMap[data.value] = data;
    }
  });

  return {
    prevNodeDataArray,
    prevNodeDataMap,
    prevLinkDataArray,
    prevLinkDataMap,
    prevModelData,
    prevRelationshipValues,
    prevMappingDataMap,
    originalIrisByCurrentIri,
    originalSpgNamesByCurrentName,
  };
};
